import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { setLoadingConfirmsAction } from '../redux/actions/confirmActions'

export const useConfirmsAction = () => {
  const { isLoadingConfirm } = useSelector(
    (state: RootState) => state.confirmAction
  )
  const dispatch = useDispatch()

  const setLoadingConfirm = (isLoadingConfirm: boolean) => {
    dispatch(setLoadingConfirmsAction(isLoadingConfirm))
  }

  return { isLoadingConfirm, setLoadingConfirm }
}
